import {
  errorMessage,
  hireflixPurchasePlanRoute,
  applicationsCountsKey,
  employerApplicationsKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

type UseHireflixPurchasePlanProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useHireflixPurchasePlan = ({
  setErrorText,
  onSuccess,
}: UseHireflixPurchasePlanProps) => {
  const client = useQueryClient();

  const {
    mutate: hireflixPurchasePlan,
    isLoading: isHireflixPurchasePlanLoading,
  } = useMutation({
    mutationFn: (variables: {
      remaining_credit_limit: number;
      amount: number;
      type?: string;
      token?: string;
      auto_refill?: boolean;
    }) =>
      axiosInstance
        .post(hireflixPurchasePlanRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        // ✅ Refresh relevant cached data
        client.invalidateQueries(employerApplicationsKey);
        client.invalidateQueries(applicationsCountsKey);
        client.invalidateQueries([profileKey]);

        onSuccess?.();
        setErrorText('');
      } else {
        setErrorText(data?.message || errorMessage);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });

  return {
    hireflixPurchasePlan,
    isHireflixPurchasePlanLoading,
  };
};
